import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.css']
})
export class BusinessComponent implements OnInit {
    public businessId: string;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.businessId = this.stateService.getStateParams()['business_id'];
    }

    private async loadEdit() {
        if (!!this.businessId) {
            this.edit = (await this.datatask.Post(1144, { business_id: this.businessId }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1145, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    business_id: string;
    business_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('business', {
//        templateUrl: 'views/components/views/business/business.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'businessService', function ($stateParams, stateService, businessService) {
//            const vm = this;
//            let businessId = $stateParams.business_id;

//            vm.model = {
//                businessId: businessId,
//                edit: {},
//                lockedSave: false
//            };

//            async function loadEdit() {
//                vm.model.edit = (await businessService.getEdit({ business_id: businessId }))[0];
//            }

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                businessService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            vm.$onInit = function () {
//                loadEdit();
//            };
//        }]
//    });
//})();
